import styles from './CenteredCta.module.css';
import Arrow from '../assets/arrowTopRight.jsx';

function CenteredCta({
    title,
    media,
    ctaText,
    cardColor,
    ctaColor,
    ctaLink,
    openLinkNew,
}) {
    const getMediaType = (url) => {
        if (!url) return null;
        const extension = url.split('.').pop().toLowerCase();
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

        if (videoExtensions.includes(extension)) return 'video';
        if (imageExtensions.includes(extension)) return 'image';
        return null;
    };
    const mediaType = getMediaType(media.fields.file.url);
    let mediaPad;
    if (mediaType === 'image') {
        mediaPad = (media.fields.file.details.image.height / media.fields.file.details.image.width) * 100;
    } else if (mediaType === 'video') {
        mediaPad = 56.25; // Default to 16:9 aspect ratio if video dimensions are unavailable
    }

    return (

        <div className={`${styles.centered_cta} preserve-line-breaks`}>

            <div className={styles.mediawrap} style={{ paddingTop: `${mediaPad}%` }}>
                {mediaType === "video" && (
                    <video className={styles.video} autoPlay loop muted playsInline>
                        <source src={media} type="video/mp4" />
                    </video>
                )}

                {mediaType === "image" && (
                    <img
                        className={styles.image}
                        src={media.fields.file.url}
                        alt={media.fields.title}
                    />
                )}
            </div>

            <div className={`${styles.card}`} style={{ backgroundColor: cardColor }}>
                <h2 className={styles.title} style={{ color: ctaColor }}>{title}</h2>

                <a href={ctaLink} className="cell" target={openLinkNew ? "_blank" : "_self"} rel={openLinkNew ? "noopener noreferrer" : undefined}>
                    <div className={`ctaBox ${styles.cta_button}`} style={{ backgroundColor: ctaColor, color: cardColor }}>
                        <div className="contents">
                            {ctaText} <Arrow />
                        </div>
                        
                    </div>
                </a>
            </div>
        </div>
    )
}

export default CenteredCta;